import React from "react";
import Hero from "../../Hero";

import useAnimation from "../../../hooks/useAnimation";
import Animation from "../../../../static/animations/zipstocks/zipstocks-hero-animation.json";

const ZipStocksHero = (props) => {
  useAnimation({
    container: "#hero__animation",
    animationData: Animation,
    assetsPath: "/animations/zipstocks/assets/hero/",
  });

  return (
    <Hero
      {...props}
      dataScroll={{
        "data-sal": "slide-up",
        "data-sal-duration": "400",
        "data-sal-easing": "ease-in-quad",
      }}
    >
      <div
        id="hero__animation"
        data-sal="fade"
        data-sal-duration="400"
        data-sal-easing="ease-in-quad"
      />
    </Hero>
  );
};

export default ZipStocksHero;
